import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IFelderResponseRow } from 'fa-kt.types';
import { FelderService } from '../service';

@Component({
  selector: 'fa-kt-felder-list',
  templateUrl: './felder-list.component.html',
  styleUrls: ['./felder-list.component.css'],
})
export class FelderListComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  @Output() select: EventEmitter<string> = new EventEmitter<string>();

  constructor(public felder: FelderService) {}

  public set(felder: IFelderResponseRow) {
    /* << custom    */
    if (felder.feld) {
      this.select.emit(felder.feld.id);
    }
    /*    custom >> */
  }
}
